import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { publicUsageReport, usage } from "../../constants/actionTypes";
import {
  setUsageSummaryData,
  setUsageSummaryError,
  setSummaryLoading,
  generateReportSuccess,
  generateReportError,
  setGenerateReportLoading,
  setReportListData,
  setReportListError,
  setReportListLoading,
  getUsageReportSkuSuccess,
  getUsageReportSkuError,
  getUsageReportSkuLoading,
  getUsageUserListSuccess,
  getUsageUserListLoading,
  getUsageUserListError,
  generatePublicReportSuccess,
  generatePublicReportError,
  setPublicGenerateReportLoading,
  setPublicReportListLoading,
  setPublicReportListError,
  setPublicReportListData,
} from "../actions";
import { fetchUsageSummaryData, generateReport, fetchReportListData, getUsageReportSkuApi, getUsageReportUsersApi, generatePublicReport, fetchPublicReportListData } from "../api";
import { statusCode } from "../../constants/apis/apiStatus";
import { toastNotification } from "../../utils/toast";
import { toasterFlags, errorWentWrong } from "../../constants/componentConstants";

export function* fetchUsageSummaryDataFunction({ payload }) {
  try {
    const data = yield call(fetchUsageSummaryData, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setUsageSummaryData(data));
    } else {
      toastNotification(toasterFlags.ERROR, data?.data?.message);
      yield put(setUsageSummaryError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(setUsageSummaryError(err));
  }
  yield put(setSummaryLoading(false));
}

export function* generateReportFunction({ payload }) {
  try {
    const data = yield call(generateReport, payload);
    if (data?.status === statusCode.Created201) {
      yield put(generateReportSuccess(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message || errorWentWrong);
      yield put(generateReportError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, errorWentWrong);
    yield put(generateReportError(err));
  }
  yield put(setGenerateReportLoading(false));
}

export function* fetchReportListFunction({ payload }) {
  try {
    const data = yield call(fetchReportListData, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setReportListData(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message || errorWentWrong);
      yield put(setReportListError(data));
    }
  } catch (err) {
    yield put(setReportListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setReportListLoading(false));
}

export function* getUsageReportSkuSaga({ payload }) {
  try {
    yield put(getUsageReportSkuLoading(true));
    const data = yield call(getUsageReportSkuApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(getUsageReportSkuSuccess(data));
    } else {
      yield put(getUsageReportSkuError(data));
    }
    yield put(getUsageReportSkuLoading(false));
  } catch (err) {
    yield put(getUsageReportSkuError(err));
  }
  yield put(getUsageReportSkuLoading(false));
}

export function* getUsageReportUserListSaga({ payload }) {
  try {
    yield put(getUsageUserListLoading(true));
    const data = yield call(getUsageReportUsersApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(getUsageUserListSuccess(data));
    } else {
      yield put(getUsageUserListError(data));
    }
    yield put(getUsageUserListLoading(false));
  } catch (err) {
    yield put(getUsageUserListError(err));
  }
  yield put(getUsageUserListLoading(false));
}

export function* fetchPublicReportListFunction({ payload }) {
  try {
    const data = yield call(fetchPublicReportListData, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setPublicReportListData(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message || errorWentWrong);
      yield put(setPublicReportListError(data));
    }
  } catch (err) {
    yield put(setPublicReportListError(err));
    toastNotification(toasterFlags.WARN, errorWentWrong);
  }
  yield put(setPublicReportListLoading(false));
}

export function* generatePublicReportFunction({ payload }) {
  try {
    const data = yield call(generatePublicReport, payload);
    if (data?.status === statusCode.Ok200) {
      // toastNotification(toasterFlags.SUCCESS, data?.data?.success);
      yield put(generatePublicReportSuccess(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message || errorWentWrong);
      yield put(generatePublicReportError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.data?.message || errorWentWrong);
    yield put(generatePublicReportError(err));
  }
  yield put(setPublicGenerateReportLoading(false));
}

export function* headerNotificationRootSaga() {
  yield takeLatest(usage.USAGE_SUMMARY_GET_DATA, fetchUsageSummaryDataFunction);
  yield takeLatest(usage.USAGE_REPORT_GENERATE_REQUEST, generateReportFunction);
  yield takeLatest(usage.REPORT_LIST_GET_DATA, fetchReportListFunction);
  yield takeLatest(usage.GET_REPORT_SKU_ACTION, getUsageReportSkuSaga);
  yield takeLatest(usage.GET_USAGE_USER_LIST_ACTION, getUsageReportUserListSaga);
  yield takeLatest(publicUsageReport.PUBLIC_REPORT_LIST_GET_DATA, fetchPublicReportListFunction);
  yield takeLatest(publicUsageReport.PUBLIC_USAGE_REPORT_GENERATE_REQUEST, generatePublicReportFunction);
}

export default function* rootSaga() {
  yield all([fork(headerNotificationRootSaga)]);
}
